import React from 'react';
import { Link } from 'react-router-dom';
import img from '../../../../images/cv-animate.png'


const BannerSection = () => {
    return (
        <div className='bg-gray-800 container mx-auto  xl:px-32'>
            <section className=" text-gray-100">
                <div className="container grid md:grid-cols-5 items-center  mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between">
                    <div className="col-span-3 mr-10 ">
                        <h1 className="text-5xl font-bold leading-none sm:text-6xl mb-20">
                            Do you want to make your Resume?
                        </h1>

                        <div className=" space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
                            <Link to='/create-resume'><button className="btn btn-primary">Create My Resume</button></Link>
                            <Link to='/my-resume'><button className="btn btn-outline btn-primary">Create My CV</button></Link>
                        </div>
                    </div>

                    <div className='col-span-2'>
                        <img className='w-[500px]' src={img} alt="" />
                    </div>

                </div>
            </section>
        </div>
    );
};

export default BannerSection;